import { AxiosClone } from './../AxiosClone';
import {api_url} from '../Configuration/Config';

//update page content
export async function updatePageContent(id,data){
    return await AxiosClone.post(`${api_url}/admin/settings/${id}`,data)
}